// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ helpers
const { formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmount, getSplittedNumber } = require('utilities/currencyHelper');

// @ constants
const { EURO_SYMBOL } = require('constants/index');
const { getMortgageTypeText } = require('constants/mortgageRequestType');

const BuildPricingSection = ({ immInsurancesPricing, typeMortgage }) => {
    const language = getLanguage();
    const insurancePricing = immInsurancesPricing.get('insurancesRelatedPricing');
    const homeInsuranceValidation = insurancePricing.first().get('homeInsurance');
    const mortgageInsurancesPricing = homeInsuranceValidation ? insurancePricing : insurancePricing.reverse();
    const mainClass = __CONTACT_CENTER__
        ? 'mortgage-request-insurances-related-modal__section-info-pricing-value-cc'
        : 'mortgage-request-insurances-related-modal__section-info-pricing-value';

    const mortgagePricingItems = mortgageInsurancesPricing.map((item, index) => {
        const feeValue = formatAmount(item.get('fee'), language, 2);
        const taeVariable = getSplittedNumber(item.get('tae', 0) * 100);
        const taeValue = `${taeVariable.whole}${taeVariable.decimalMark}${taeVariable.decimals}`
        const tinValue = formatAmount(item.get('fixedInterest'), language, 2);
        const taeInformation = formatText("mortgageRequestPanel-insuranceRelatedTAE", [tinValue, taeValue]);

        let mortgageInsurance1 = formatText("mortgageRequestPanel-mortgageRequestPanel_mortgageHasntInsuranceRelated1", [getMortgageTypeText(typeMortgage)]);
        let mortgageInsurance2 = formatText("mortgageRequestPanel-mortgageRequestPanel_mortgageHasntInsuranceRelated2");

        if (item.get('homeInsurance')) {
            mortgageInsurance1 = formatText("mortgageRequestPanel-mortgageRequestPanel_mortgageHasInsuranceRelated1", [getMortgageTypeText(typeMortgage)]);
            mortgageInsurance2 = formatText("mortgageRequestPanel-mortgageRequestPanel_mortgageHasInsuranceRelated2");
        }
        const hasInsurance = (
            <React.Fragment>
                <span>{mortgageInsurance1}</span>
                <span className={`${mainClass}--description-mortgage`}>{mortgageInsurance2}</span>
            </React.Fragment>
        );

        const pricingCategory = (
            <div key={index} className={`row ${mainClass}`}>
                <span className={`${mainClass}--price`}>
                    {`${feeValue} ${EURO_SYMBOL}`}
                </span>
                <span className={`${mainClass}--name`}>
                    {hasInsurance}
                </span>
                <span className={`${mainClass}--percentage`}>
                    {taeInformation}
                </span>
            </div>
        );

        return pricingCategory;
    });

    return mortgagePricingItems;
};

BuildPricingSection.propTypes = {
    immInsurancesPricing: PropTypes.object.isRequired,
    typeMortgage: PropTypes.string,
};

module.exports = BuildPricingSection;
